const pocitaniDoDeseti = () => {
	return [
		{
			id: 1,
			priklad: '2 + 5',
			moznosti: [
				{
					id: 1,
					moznost: '5',
				},
				{
					id: 2,
					moznost: '7',
				},
				{
					id: 3,
					moznost: '9',
				},
				{
					id: 4,
					moznost: '8',
				},
			],
			vysledek: '7',
		},
		{
			id: 2,
			priklad: '10 - 2',
			moznosti: [
				{
					id: 1,
					moznost: '8',
				},
				{
					id: 2,
					moznost: '7',
				},
				{
					id: 3,
					moznost: '6',
				},
				{
					id: 4,
					moznost: '2',
				},
			],
			vysledek: '8',
		},
		{
			id: 3,
			priklad: '1 + 0',
			moznosti: [
				{
					id: 1,
					moznost: '0',
				},
				{
					id: 2,
					moznost: '2',
				},
				{
					id: 3,
					moznost: '1',
				},
				{
					id: 4,
					moznost: '6',
				},
			],
			vysledek: '1',
		},
		{
			id: 4,
			priklad: '6 + 3',
			moznosti: [
				{
					id: 1,
					moznost: '7',
				},
				{
					id: 2,
					moznost: '10',
				},
				{
					id: 3,
					moznost: '9',
				},
				{
					id: 4,
					moznost: '8',
				},
			],
			vysledek: '9',
		},
		{
			id: 5,
			priklad: '3 + 2',
			moznosti: [
				{
					id: 1,
					moznost: '5',
				},
				{
					id: 2,
					moznost: '9',
				},
				{
					id: 3,
					moznost: '7',
				},
				{
					id: 4,
					moznost: '2',
				},
			],
			vysledek: '5',
		},
		{
			id: 6,
			priklad: '9 - 3',
			moznosti: [
				{
					id: 1,
					moznost: '7',
				},
				{
					id: 2,
					moznost: '6',
				},
				{
					id: 3,
					moznost: '9',
				},
				{
					id: 4,
					moznost: '5',
				},
			],
			vysledek: '6',
		},
		{
			id: 7,
			priklad: '9 - 9',
			moznosti: [
				{
					id: 1,
					moznost: '2',
				},
				{
					id: 2,
					moznost: '9',
				},
				{
					id: 3,
					moznost: '2',
				},
				{
					id: 4,
					moznost: '0',
				},
			],
			vysledek: '0',
		},
		{
			id: 8,
			priklad: '0 + 0',
			moznosti: [
				{
					id: 1,
					moznost: '1',
				},
				{
					id: 2,
					moznost: '4',
				},
				{
					id: 3,
					moznost: '0',
				},
				{
					id: 4,
					moznost: '2',
				},
			],
			vysledek: '0',
		},
		{
			id: 9,
			priklad: '3 + 5',
			moznosti: [
				{
					id: 1,
					moznost: '3',
				},
				{
					id: 2,
					moznost: '7',
				},
				{
					id: 3,
					moznost: '9',
				},
				{
					id: 4,
					moznost: '8',
				},
			],
			vysledek: '8',
		},
		{
			id: 10,
			priklad: '4 - 3',
			moznosti: [
				{
					id: 1,
					moznost: '1',
				},
				{
					id: 2,
					moznost: '3',
				},
				{
					id: 3,
					moznost: '2',
				},
				{
					id: 4,
					moznost: '0',
				},
			],
			vysledek: '1',
		},
		{
			id: 11,
			priklad: '10 - 6',
			moznosti: [
				{
					id: 1,
					moznost: '2',
				},
				{
					id: 2,
					moznost: '3',
				},
				{
					id: 3,
					moznost: '5',
				},
				{
					id: 4,
					moznost: '4',
				},
			],
			vysledek: '4',
		},
		{
			id: 12,
			priklad: '10 - 9',
			moznosti: [
				{
					id: 1,
					moznost: '5',
				},
				{
					id: 2,
					moznost: '3',
				},
				{
					id: 3,
					moznost: '2',
				},
				{
					id: 4,
					moznost: '1',
				},
			],
			vysledek: '1',
		},
		{
			id: 13,
			priklad: '8 - 5',
			moznosti: [
				{
					id: 1,
					moznost: '3',
				},
				{
					id: 2,
					moznost: '2',
				},
				{
					id: 3,
					moznost: '4',
				},
				{
					id: 4,
					moznost: '5',
				},
			],
			vysledek: '3',
		},
		{
			id: 14,
			priklad: '9 - 7',
			moznosti: [
				{
					id: 1,
					moznost: '5',
				},
				{
					id: 2,
					moznost: '3',
				},
				{
					id: 3,
					moznost: '2',
				},
				{
					id: 4,
					moznost: '4',
				},
			],
			vysledek: '2',
		},
		{
			id: 15,
			priklad: '10 - 10',
			moznosti: [
				{
					id: 1,
					moznost: '0',
				},
				{
					id: 2,
					moznost: '10',
				},
				{
					id: 3,
					moznost: '2',
				},
				{
					id: 4,
					moznost: '1',
				},
			],
			vysledek: '0',
		},
		{
			id: 16,
			priklad: '2 + 2',
			moznosti: [
				{
					id: 1,
					moznost: '4',
				},
				{
					id: 2,
					moznost: '7',
				},
				{
					id: 3,
					moznost: '5',
				},
				{
					id: 4,
					moznost: '8',
				},
			],
			vysledek: '4',
		},
		{
			id: 17,
			priklad: '2 + 1',
			moznosti: [
				{
					id: 1,
					moznost: '5',
				},
				{
					id: 2,
					moznost: '3',
				},
				{
					id: 3,
					moznost: '4',
				},
				{
					id: 4,
					moznost: '2',
				},
			],
			vysledek: '3',
		},
		{
			id: 18,
			priklad: '9 - 2',
			moznosti: [
				{
					id: 1,
					moznost: '8',
				},
				{
					id: 2,
					moznost: '7',
				},
				{
					id: 3,
					moznost: '9',
				},
				{
					id: 4,
					moznost: '6',
				},
			],
			vysledek: '7',
		},
		{
			id: 19,
			priklad: '1 + 9',
			moznosti: [
				{
					id: 1,
					moznost: '10',
				},
				{
					id: 2,
					moznost: '9',
				},
				{
					id: 3,
					moznost: '7',
				},
				{
					id: 4,
					moznost: '8',
				},
			],
			vysledek: '10',
		},
		{
			id: 20,
			priklad: '6 + 3',
			moznosti: [
				{
					id: 1,
					moznost: '7',
				},
				{
					id: 2,
					moznost: '8',
				},
				{
					id: 3,
					moznost: '9',
				},
				{
					id: 4,
					moznost: '10',
				},
			],
			vysledek: '9',
		},
		{
			id: 21,
			priklad: '5 + 2',
			moznosti: [
				{
					id: 1,
					moznost: '6',
				},
				{
					id: 2,
					moznost: '8',
				},
				{
					id: 3,
					moznost: '9',
				},
				{
					id: 4,
					moznost: '7',
				},
			],
			vysledek: '7',
		},
		{
			id: 22,
			priklad: '2 + 3',
			moznosti: [
				{
					id: 1,
					moznost: '7',
				},
				{
					id: 2,
					moznost: '8',
				},
				{
					id: 3,
					moznost: '5',
				},
				{
					id: 4,
					moznost: '6',
				},
			],
			vysledek: '5',
		},
		{
			id: 23,
			priklad: '5 + 3',
			moznosti: [
				{
					id: 1,
					moznost: '7',
				},
				{
					id: 2,
					moznost: '9',
				},
				{
					id: 3,
					moznost: '5',
				},
				{
					id: 4,
					moznost: '8',
				},
			],
			vysledek: '8',
		},
		{
			id: 24,
			priklad: '9 + 1',
			moznosti: [
				{
					id: 1,
					moznost: '10',
				},
				{
					id: 2,
					moznost: '9',
				},
				{
					id: 3,
					moznost: '7',
				},
				{
					id: 4,
					moznost: '8',
				},
			],
			vysledek: '10',
		},
	];
};

export default pocitaniDoDeseti;